import { createAction } from '@reduxjs/toolkit';
import { FaqState } from './faq.types';

export const clearFaqAction = createAction('faq/clear');
export const updateContentAction = createAction<FaqState['content']>('faq/updateContent');
